/**
 * Banner exibido ao médico quando o cadastro foi recusado.
 * Mensagem amigável, sem expor detalhes internos da decisão.
 */
import { AlertTriangle } from 'lucide-react';

export const DOCTOR_REJECTION_MESSAGE =
  'Seu cadastro médico não foi aprovado no momento. Para mais informações, entre em contato com o suporte.';

export function DoctorRejectionNotice() {
  return (
    <div
      role="alert"
      className="rounded-xl border border-red-200 dark:border-red-900/50 bg-red-50 dark:bg-red-950/30 p-5 flex items-start gap-4"
    >
      <div className="shrink-0 w-11 h-11 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center">
        <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400" />
      </div>
      <div className="min-w-0">
        <h3 className="text-base font-semibold text-red-900 dark:text-red-100">
          Cadastro não aprovado
        </h3>
        <p className="mt-1 text-sm text-red-800 dark:text-red-200 leading-relaxed">
          {DOCTOR_REJECTION_MESSAGE}
        </p>
      </div>
    </div>
  );
}
